import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Container,
  Logo,
  LogoMobile,
  LogoMobileFooter,
  Header,
  HeaderMobile,
  FormContainer,
  LoginTitle,
  LoginBox,
  LeftContainer,
  RightContainer,
  FirstAccessContainer,
  SignInButton,
  Background,
  GradienteCenter,
  ImageCenterContainer,
  GradienteMobileImage
} from "./styles";
import SignUpForm from "~/components/pages/SignUp/Form";
import SliderImages from '~/components/layout/SliderImages';

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';

import LogoMap from '~/assets/images/Login/meu-app-branca.png';
import LogoWhite from '~/assets/images/Login/logo-branca.png';

function SignUp() {
  const dispatch = useDispatch();
  const step = useSelector((state) => state.accessReducer.stepFirstAcess);
  const [showPrivacyModal, setShowPrivacyModal] = useState(true);

  const history = useHistory();

  return (
    <Background>
      <GradienteCenter/>
      <GradienteMobileImage />
      <Container>
        <LeftContainer>
          <>
            <img src={LogoWhite} alt='Ultragas'/>
          </>
        </LeftContainer>
        <ImageCenterContainer>
          <SliderImages />
        </ImageCenterContainer>
        <RightContainer>
          <LoginBox>
            <Header className="pt-4 pb-4">
              <Logo src={LogoMap} alt='MAP'/>
            </Header>
            <HeaderMobile className="pt-4 pb-4">
              <LogoMobile src={LogoWhite} alt='UltraGaz'/>
            </HeaderMobile>
            <FormContainer>
              <LoginTitle className="mb-3">Primeiro Acesso</LoginTitle>
              <SignUpForm showPrivacyModal={showPrivacyModal} setShowPrivacyModal={setShowPrivacyModal} />
              <FirstAccessContainer className="mt-3 w-100">
                {step !== 6 ? (
                  <SignInButton
                    outline
                    onClick={() => {
                      if (step === 1 || step === 6) {
                        history.push('/acessar');
                        dispatch({ type: "STEP", step: 1 });
                      } else if (step === 2 || step === 3) {
                        dispatch({ type: "STEP", step: step - 1 });
                      } else if (step === 4 || step === 7) {
                        dispatch({ type: "STEP", step: 2 });
                      } else if (step === 5) {
                        dispatch({ type: "STEP", step: 3 });
                      }
                    }}
                  >
                    <>
                      <span>Voltar</span>
                    </>
                  </SignInButton>
                ) : null}
              </FirstAccessContainer>
            </FormContainer>
            <HeaderMobile className="pt-4 pb-4">
              <LogoMobileFooter src={LogoMap} alt='UltraGaz'/>
            </HeaderMobile>
          </LoginBox>
        </RightContainer>
      </Container>
    </Background>
  );
}

export default connect()(SignUp);
